<template>
  <Header @open-cart="isCartOpen = true" @open-wishlist="isWishlistOpen = true" />
  
  <UMain>
    <UContainer v-if="!route.meta.fullWidth" class="pt-6">
      <slot />
    </UContainer>
    <slot v-else />

    <ClientOnly>
        <CartDrawer v-model:open="isCartOpen" />
        <WishlistDrawer v-model:open="isWishlistOpen" />
        <ScrollTopButton :scroll-offset="600" />
    </ClientOnly>
  </UMain>
  <StoreModals />
  <Footer />
</template>

<script setup lang="ts">
import CartDrawer from '~/components/organisms/CartDrawer.vue'
import WishlistDrawer from '~/components/organisms/WishlistDrawer.vue'
import Header from '~/components/organisms/Header.vue'
import Footer from '~/components/organisms/Footer.vue'
import ScrollTopButton from '~/components/molecules/ScrollTopButton.vue'

const isCartOpen = ref(false)
const isWishlistOpen = ref(false)

const route = useRoute()
</script>
